import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-24/task-02";

const task: Slide = {
  title: "Select whether a statement is true or false.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
